module.exports = __webpack_public_path__ + "static/img/grow2_light.9a064d8b.png";